import React from 'react';
import CargomaticModal from 'components/v2/modal';
import { titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import StandardAccessorialRates from './StandardAccessorialRates';
export default ({ show, onHide, onSave, market, type, canUpdate }) => {
    const { t } = useTranslation();
    return (React.createElement(CargomaticModal, { dataTestId: "CargomaticModal-45ff0503", style: { top: '5%' }, dialogClassName: "rounded-xl border-2 border-green-cm w-full", showHeader: false, show: show, onHide: onHide, body: React.createElement("div", { "data-testid": "div-3ffeba1b", className: "relative" },
            React.createElement("h2", { "data-testid": "h2-78c7a720", className: "text-xl bold m-0 mb-5" }, t('TYPE_STANDARD_ACCESSORIAL_CARD_MARKET', {
                type: titleize(type),
                market: titleize(market),
            })),
            React.createElement("div", { "data-testid": "div-e39e2df1", className: "flex-auto" },
                React.createElement(StandardAccessorialRates, { markets: market, canUpdate: canUpdate, type: type, onHide: onHide }))) }));
};
